import React from "react";

import ToTitleCase from "../../../core/utils/toTitleCase";
import SimpleRenderField from "./utils/SimpleRenderField";

function SimpleTable(props) {
    return (
        <table className="table table-striped table-bordered table-responsive">
            <thead>
                <tr>
                    {props.columns.map((column, index) => {
                        return (
                            <td key={`thead-${column.fieldName}-${index}`}>
                                <div className="text-center font-weight-bold">
                                    <span className="pointer" onClick={(event) => this.toggleSort(event, column)}>
                                        <span className="pl-4 pr-4 ">{ToTitleCase(column.fieldName)}&nbsp;</span>
                                    </span>
                                </div>
                            </td>
                        );
                    })}

                </tr>
            </thead>

            <tbody>
                {(!Array.isArray(props.data) || props.data.length == 0) ?
                    <div className="pad-all">
                        No data found
                    </div>
                    :
                    props.columns.length == 0 ?
                        "Show at least one column to view data"
                        :
                        props.data.map((row, index) => {
                            return (
                                <tr key={index}>
                                    {props.columns.map((column, colIndex) => {
                                        let renderedColumn = row[column.fieldName];

                                        renderedColumn = SimpleRenderField({
                                            appUUID: props.appUUID,
                                            data: row,
                                            column: column,
                                            applicationUsers: props.applicationUsers,

                                            lookupDataMappedToTable: props.lookupDataMappedToTable,
                                            secondaryLookupFields: props.secondaryLookupFields,
                                            secondaryComputedLookupData: props.secondaryComputedLookupData,
                                        })

                                        return (
                                            <td key={`${index}-${colIndex}`}>
                                                <div className="text-wrap">
                                                    {renderedColumn}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
            </tbody>
        </table>
    )
}

export default SimpleTable;